import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import FloorMapCard from "components/siteRepo/common/floorMapCard";
import { useParams } from "react-router-dom";
import Button from "react-bootstrap/Button";
import { projectsPlaceHolders } from "utils/common";

const SelectFloorPlans = ({
  siteData,
  selectedFloorPlans,
  updateLayerSelection,
  updateProjectSelection,
  isShowProjectView,
}) => {
  const navigate = useNavigate();
  const { siteId } = useParams();
  const [isSelectAllFloorsChecked, setIsSelectAllFloorsChecked] = useState(false);

  const handleFloorSelection = (e, selectionData) => {
    const { layer } = selectionData.data;
    updateLayerSelection(layer);

    // mirror updateLayerSelection's toggle logic to know the resulting selection before the prop re-renders
    const isCurrentlySelected = selectedFloorPlans?.includes(layer.layerId);
    const updatedSelectedLayers = isCurrentlySelected
      ? selectedFloorPlans.filter((id) => id !== layer.layerId)
      : [...(selectedFloorPlans || []), layer.layerId];
    const siteDataCopy = JSON.parse(JSON.stringify(siteData));
    const allLayerIds =
      siteDataCopy?.projectDetailsList?.flatMap(
        (project) => project.layerInfoList?.map((layerItem) => layerItem.layerId) || [],
      ) || [];

    setIsSelectAllFloorsChecked(
      allLayerIds.length > 0 && allLayerIds.every((id) => updatedSelectedLayers.includes(id)),
    );
  };

  const handleSelectProject = (projectData) => {
    const isCurrentlyChecked = !!projectData.isProjectChecked;
    updateProjectSelection(projectData, !isCurrentlyChecked);

    // mirror updateProjectSelection's toggle logic to know the resulting selection before the prop re-renders
    const projectLayerIds = projectData.layerInfoList?.map((layerItem) => layerItem.layerId) || [];
    const updatedSelectedLayers = isCurrentlyChecked
      ? (selectedFloorPlans || []).filter((id) => !projectLayerIds.includes(id))
      : [...new Set([...(selectedFloorPlans || []), ...projectLayerIds])];
    const siteDataCopy = JSON.parse(JSON.stringify(siteData));
    const allLayerIds =
      siteDataCopy?.projectDetailsList?.flatMap(
        (project) => project.layerInfoList?.map((layerItem) => layerItem.layerId) || [],
      ) || [];

    setIsSelectAllFloorsChecked(
      allLayerIds.length > 0 && allLayerIds.every((id) => updatedSelectedLayers.includes(id)),
    );
  };

  const handleSelectAllFloorPlans = () => {
    setIsSelectAllFloorsChecked(!isSelectAllFloorsChecked);
    if (!isSelectAllFloorsChecked) {
      updateLayerSelection("", true);
    } else {
      updateLayerSelection("", false);
    }
  };

  return (
    <>
      {isShowProjectView && (
        <div className="container-proj">
          <div className="d-flex align-items-center checkBox-sty">
            <input
              type="checkbox"
              className="select-floor-plans-select-all-checkbox"
              onChange={(e) => handleSelectAllFloorPlans()}
              checked={isSelectAllFloorsChecked}
            />
            <label>Select All Floor Plans</label>
          </div>

          {siteData.projectDetailsList && siteData.projectDetailsList.length
            ? siteData.projectDetailsList?.map((project, idx) => {
                return (
                  <div className="project-container quote-spacing" key={idx + project.mprojectId}>
                    <div className="col-12 d-flex proj-header justify-content-between">
                      <div className="d-flex align-items-center">
                        <input
                          type="checkbox"
                          className="select-floor-plans-select-all-checkbox"
                          onChange={(e) => handleSelectProject(project)}
                          checked={!!project.isProjectChecked}
                        />
                        <span className="item-header">Floor Plan (Project) Name:</span>
                        <span className="item-label">{project.name}</span>
                      </div>
                    </div>
                    <div className="row floors">
                      <div className="d-flex flex-column flex-md-row flex-wrap">
                        {project.layerInfoList.map((layerItem, index) => {
                          return (
                            <FloorMapCard
                              key={index}
                              layerIndex={layerItem.elementIndex}
                              layerObject={layerItem}
                              projectView={true}
                              project={project}
                              handleSelection={handleFloorSelection}
                              isCreateQuote={true}
                              isFloorSelected={selectedFloorPlans?.includes(layerItem.layerId)}
                            />
                          );
                        })}
                      </div>
                    </div>
                  </div>
                );
              })
            : ""}
        </div>
      )}

      {!isShowProjectView && (
        <div className="mt-5 mt-md-0 select-floor-plans d-flex flex-column justify-content-between">
          <div className="search-form-container px-0 border-0 no-shadow">
            <div className="search-form-container__fields">
              <div className="d-flex align-items-center">
                <input
                  type="checkbox"
                  className="select-floor-plans-select-all-checkbox"
                  onChange={(e) => handleSelectAllFloorPlans()}
                  checked={isSelectAllFloorsChecked}
                />
                <label>Floor Plans</label>
              </div>
              <hr />
              <div className="d-flex flex-column flex-md-row flex-wrap">
                {siteData?.projectDetailsList?.map((project) => {
                  return (
                    project.layerInfoList?.length &&
                    project.layerInfoList.map((layerItem, index) => {
                      return (
                        <FloorMapCard
                          key={index}
                          layerView={true}
                          layerIndex={layerItem.elementIndex}
                          layerObject={layerItem}
                          project={project}
                          handleSelection={handleFloorSelection}
                          isCreateQuote={true}
                          isFloorSelected={selectedFloorPlans?.includes(layerItem.layerId)}
                        />
                      );
                    })
                  );
                })}
              </div>
              {!siteData?.projectDetailsList && projectsPlaceHolders()}
            </div>
          </div>
        </div>
      )}

      <div className="d-flex justify-content-between flex-column-reverse flex-md-row footer-actions">
        <Button variant="outline-primary" onClick={() => navigate(`/siteRepo/site/${siteId}`)}>
          Back
        </Button>
        <Button
          className="m-0"
          variant="primary"
          disabled={selectedFloorPlans?.length === 0}
          onClick={() => navigate(`/siteRepo/createQuote/${siteId}#select-products`)}
        >
          Next
        </Button>
      </div>
    </>
  );
};

export default SelectFloorPlans;
